import { render, staticRenderFns } from "./CommercialDialCampaign.vue?vue&type=template&id=db668c4a&scoped=true"
import script from "./CommercialDialCampaign.vue?vue&type=script&lang=js"
export * from "./CommercialDialCampaign.vue?vue&type=script&lang=js"
import style0 from "./CommercialDialCampaign.vue?vue&type=style&index=0&id=db668c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db668c4a",
  null
  
)

export default component.exports